import 'bootstrap/dist/css/bootstrap.css';
import { cpf as cpfValidacao } from 'cpf-cnpj-validator';
import { useEffect, useState, useMemo, useRef } from 'react'; 
import InputMask from 'react-input-mask';
import { useLocation, useParams } from 'react-router-dom';
import { EnderecoDTO } from '../../../shared/dto/enderecoDTO';
import { GerenteDTO } from '../../../shared/dto/gerenteDTO';
import { Promotora } from '../../../shared/model/promotora';
import Spinner from '../../../shared/spinner';
import { Button, Row, Col, Form } from 'react-bootstrap'; 
import PromotoraService from '../../../services/promotoraService'; 
import SupervisorService from '../../../services/supervisorService';
import ViaCepService from '../../../services/viaCepService';
import CustomAlert from '../../../shared/customAlert';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import { Regional } from '../../../shared/model/regional'; 
import { Comercial } from '../../../shared/model/comercial'; 
import RegionalService from '../../../services/regionalService'; 
import ComercialService from '../../../services/comercialService'; 
import DualListBox from '../../../shared/DualListBox'; 
import PontoDeVendaService from '../../../services/pontoVendaService'; 
import { PromotoraFiltroDTO } from '../../../shared/dto/promotoraFiltroDTO';

interface ListItem {
  id: number | string;
  nome: string;
}

interface RegionalListItem extends Regional { id: number | null; nome: string; }
interface ComercialListItem extends Comercial { id: number | null; nome: string; }


function SupervisorInclusaoAlteracao() {
  useVerificaPermissao();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const location = useLocation();
  const { id } = location.state || {};
  const { tipo } = useParams();

  const isInitialMount = useRef(true);
  const [tipoVinculo, setTipoVinculo] = useState('PROMOTORA');
  const [regionais, setRegionais] = useState<RegionalListItem[]>([]);
  const [selectedRegionais, setSelectedRegionais] = useState<ListItem[]>([]); 
  const [comerciais, setComerciais] = useState<ComercialListItem[]>([]);
  const [selectedComerciais, setSelectedComerciais] = useState<ListItem[]>([]); 
  const [showRegionalBox, setShowRegionalBox] = useState(false);
  const [showComercialBox, setShowComercialBox] = useState(false);
  const [promotora, setPromotora] = useState(''); 
  const [promotoras, setPromotoras] = useState<Promotora[]>([]);
  const [pontosDeVenda, setPontosDeVenda] = useState<ListItem[]>([]);
  const [selectedPontoDeVenda, setSelectedPontoDeVenda] = useState<ListItem[]>([]);
  const [showPdvBox, setShowPdvBox] = useState(false);

  
  const [nome, setNome] = useState('');
  const [cpf, setCpf] = useState('');
  const [numeroCertificacao, setNumeroCertificacao] = useState('');
  const [emails, setEmails] = useState('');
  const [telefoneComercial, setTelefoneComercial] = useState('');
  const [telefoneCelular, setTelefoneCelular] = useState('');
  const [cep, setCep] = useState('');
  const [logradouro, setLogradouro] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [bairro, setBairro] = useState('');
  const [localidade, setLocalidade] = useState('');
  const [uf, setUf] = useState('');
  const [codigoExterno, setCodigoExterno] = useState('')

  const [loading, setLoading] = useState(false);
  const [loadingHierarquia, setLoadingHierarquia] = useState(false); 

  const promotoraService: PromotoraService = new PromotoraService();
  const supervisorService: SupervisorService = new SupervisorService();
  const viaCepService: ViaCepService = new ViaCepService();
  const regionalService: RegionalService = new RegionalService();
  const comercialService: ComercialService = new ComercialService();
  const pontoDeVendaService: PontoDeVendaService = new PontoDeVendaService();

  


 const handleChangePromotora = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const novaPromotora = e.target.value;
    setPromotora(novaPromotora);
    

    setSelectedRegionais([]);
    setSelectedComerciais([]);
    setSelectedPontoDeVenda([]); 
  };
  const carregarHierarquiaDaPromotora = async (promotoraId: string) => {
      if (!promotoraId) {
          setRegionais([]);
          setComerciais([]);
          return;
      }
      setLoadingHierarquia(true);
      try {
          const response = await promotoraService.listarPromotoraPorId(promotoraId);
          const promotoraData = response.data;
          setRegionais(promotoraData.regionais || []);
          setComerciais(promotoraData.comerciais || []);
          setPontosDeVenda(promotoraData.pontosDeVenda || []);
          
      } catch (err) {
          console.error("Erro ao carregar hierarquia da promotora:", err);
          setAlert({ message: "Erro ao carregar vínculos da promotora.", type: 'error' });
          setRegionais([]);
          setComerciais([]);
      } finally {
          setLoadingHierarquia(false);
      }
  };

  const carregarHierarquiaLivre = async () => {
      setLoadingHierarquia(true);
      try {

          const [regionaisRes, comerciaisRes,pontoDeVendaRes] = await Promise.all([
              regionalService.listarTodasRegionaisAtivas(), 
              comercialService.listarTodasComerciaisAtivas(),
              pontoDeVendaService.listarTodosPontosVendasAtivos()
              
          ]);
          
          setRegionais(regionaisRes.data || []);
          setComerciais(comerciaisRes.data || []);
          setPontosDeVenda(pontoDeVendaRes.data || []);

      } catch (err) {
          console.error("Erro ao carregar hierarquia livre:", err);
          setAlert({ message: "Erro ao carregar lista de Regionais/Comerciais.", type: 'error' });
          setRegionais([]);
          setComerciais([]);
      } finally {
          setLoadingHierarquia(false);
      }
  };

const availablePontosDeVenda = useMemo(() => {
    const selectedIds = new Set(selectedPontoDeVenda.map(p => String(p.id)));
    
    return pontosDeVenda 
      .map(p => ({ id: p.id!, nome: p.nome })) 
      .filter(p => !selectedIds.has(String(p.id)))
      .sort((a, b) => a.nome.localeCompare(b.nome));
  }, [pontosDeVenda, selectedPontoDeVenda]);

  const handleMovePdvToSelected = (items: ListItem[]) => setSelectedPontoDeVenda(prev => [...prev, ...items].sort((a, b) => a.nome.localeCompare(b.nome)));
  const handleMovePdvToAvailable = (items: ListItem[]) => {
    const idsToMove = new Set(items.map(i => i.id));
    setSelectedPontoDeVenda(prev => prev.filter(i => !idsToMove.has(i.id)));
  };
  const handleMoveAllPdvsToSelected = () => setSelectedPontoDeVenda([...pontosDeVenda.map(p => ({ id: p.id!, nome: p.nome }))].sort((a, b) => a.nome.localeCompare(b.nome)));
  const handleMoveAllPdvsToAvailable = () => setSelectedPontoDeVenda([]);


const listarGerentePorId = async () => {
    setLoading(true);
    try {
      const response = await supervisorService.listarGerentePorId(id);
      const jsonGerente = response.data; 
      
      const tipoVinculoDoGerente = jsonGerente.tipoVinculo || 'PROMOTORA';
      setTipoVinculo(tipoVinculoDoGerente);

      const promotoraIdDoGerente = jsonGerente.idPromotora.toString();
      setPromotora(promotoraIdDoGerente); 
      
      setNome(jsonGerente.nome);
      setCpf(jsonGerente.cpf);
      setEmails(jsonGerente.email);
      setNumeroCertificacao(jsonGerente.numeroCertificacao);
      setTelefoneComercial(jsonGerente.foneComercial);
      setTelefoneCelular(jsonGerente.foneCelular);
      setCep(jsonGerente.cep || jsonGerente.enderecoDTO?.cep || '');
      setLogradouro(jsonGerente.endereco || jsonGerente.enderecoDTO?.logradouro || '');
      setNumero(jsonGerente.numeroEndereco || jsonGerente.enderecoDTO?.numero || '');
      setComplemento(jsonGerente.complemento || jsonGerente.enderecoDTO?.complemento || '');
      setBairro(jsonGerente.bairro || jsonGerente.enderecoDTO?.bairro || '');
      setLocalidade(jsonGerente.cidade || jsonGerente.enderecoDTO?.localidade || '');
      setUf(jsonGerente.uf || jsonGerente.enderecoDTO?.uf || '');
      setCodigoExterno(jsonGerente.codigoExterno);
   
      if (jsonGerente.regionais && Array.isArray(jsonGerente.regionais) && jsonGerente.regionais.length > 0) {
        setSelectedRegionais(jsonGerente.regionais.map((r: any) => ({ id: r.id, nome: r.nome })));
        setShowRegionalBox(true); 
      }
      if (jsonGerente.comerciais && Array.isArray(jsonGerente.comerciais) && jsonGerente.comerciais.length > 0) {
        setSelectedComerciais(jsonGerente.comerciais.map((c: any) => ({ id: c.id, nome: c.nome })));
        setShowComercialBox(true); 
      }

      if (jsonGerente.pontosDeVenda && Array.isArray(jsonGerente.pontosDeVenda) && jsonGerente.pontosDeVenda.length > 0) {
        setSelectedPontoDeVenda(jsonGerente.pontosDeVenda.map((p: any) => ({ id: p.id, nome: p.nome })));
        setShowPdvBox(true); 
      }
      
    } catch (err) {
      console.error(err);
      setAlert({ message: "Erro ao carregar dados do Supervisor.", type: 'error' });
    } finally {
      setLoading(false);
    }
  }

 const limparCampos = () => {
    setNome(''); 
    setCpf(''); 
    setEmails(''); 
    setNumeroCertificacao('');
    setTelefoneComercial(''); 
    setTelefoneCelular(''); 
    setCep('');
    setLogradouro(''); 
    setNumero(''); 
    setComplemento(''); 
    setBairro('');
    setLocalidade(''); 
    setUf(''); 
    setCodigoExterno('');    
    setPromotora('');
    setSelectedRegionais([]); 
    setSelectedComerciais([]);
    setShowRegionalBox(false); 
    setShowComercialBox(false);
    setSelectedPontoDeVenda([]);
    setShowPdvBox(false);
    setTipoVinculo('PROMOTORA'); 
  }

const handleSubmit = async (event: any) => {
    event.preventDefault(); 

    if (!cpfValidacao.isValid(cpf)) {
      setAlert({ message: 'CPF Inválido', type: 'warning' });
      return;
    } 
    
    setLoading(true);
    let endereco : EnderecoDTO = new EnderecoDTO();
    endereco.cep = cep;
    endereco.logradouro = logradouro;
    endereco.numero = numero;
    endereco.complemento = complemento;
    endereco.bairro = bairro;
    endereco.uf = uf;
    endereco.localidade = localidade;
    
    let gerenteDTO: GerenteDTO = new GerenteDTO();
    
    // @ts-ignore
    gerenteDTO.tipoVinculo = tipoVinculo; 
    gerenteDTO.promotora = Number(promotora); 
    gerenteDTO.idsRegionais = selectedRegionais.map(r => r.id);
    gerenteDTO.idsComerciais = selectedComerciais.map(c => c.id);
    gerenteDTO.idsPontosDeVenda = selectedPontoDeVenda.map(p => p.id);
    

    gerenteDTO.id = id ? String(id) : null;
    gerenteDTO.nome = nome;
    gerenteDTO.cpf = cpf;
    gerenteDTO.email = emails;
    gerenteDTO.numeroCertificacao = numeroCertificacao;
    gerenteDTO.enderecoDTO = endereco;
    gerenteDTO.telefoneComercial = telefoneComercial;
    gerenteDTO.telefoneCelular = telefoneCelular;
    gerenteDTO.codigoExterno = codigoExterno;
    

    try {
      await supervisorService.incluirAlterarGerente(gerenteDTO);
      setLoading(false);
      setAlert({ message: 'Supervisor salvo com sucesso!', type: 'success' });
    } catch (err: any) {
      setLoading(false);
      const msg = err.response?.data || "Ocorreu um erro ao salvar.";
      setAlert({ message: msg, type: 'error' });
      console.error(err);
    }
  };

  const viaCep = async (cep: string) => {
    if (cep !== undefined && cep !== '' && cep.length === 10) {
      console.log(cep)
      setLoading(true);
      const cepWithoutMask = cep.replace(/\D/g, '');
      try {
        const response = await viaCepService.viaCep(cepWithoutMask);
        const jsonViaCep = response.data;
        setLogradouro(jsonViaCep.logradouro);
        setLocalidade(jsonViaCep.localidade);
        setUf(jsonViaCep.uf);
        setBairro(jsonViaCep.bairro);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.error(err);
      }
    }
  };

 useEffect(() => {
    const carregarListasIniciais = async () => {
      setLoading(true);
      try {
        let filtros: PromotoraFiltroDTO = new PromotoraFiltroDTO();
        const promotoraRes = await promotoraService.listarTodasPromotoras(0, 999999, filtros);

        if (promotoraRes.data.content) {
          setPromotoras(promotoraRes.data.content);
          if (tipo === 'inclusao' && promotoraRes.data.content.length > 0) {
            setPromotora(promotoraRes.data.content[0].id.toString()); 
          }
        }
        
      } catch (err) {
        console.error("Erro ao carregar lista de promotoras:", err);
        setAlert({ message: "Erro ao carregar lista de promotoras.", type: 'error' });
      } finally {
        if (tipo !== 'alteracao') { 
          setLoading(false);
        }
      }
    };

    

    if (tipo === 'alteracao' && id) {
      carregarListasIniciais(); 
      
      listarGerentePorId();
    } else {
      carregarListasIniciais();
    }
  }, [tipo, id]);

  useEffect(() => {

    if (tipoVinculo === 'ENTIDADE') {
        if (!isInitialMount.current) {
            setSelectedRegionais([]);
            setSelectedComerciais([]);
        }
        carregarHierarquiaLivre();
    } 
    
    else {
        if (promotora) {
            carregarHierarquiaDaPromotora(promotora);
        } else {
            setRegionais([]);
            setComerciais([]);
            setSelectedRegionais([]);
            setSelectedComerciais([]);
        }
    }

    isInitialMount.current = false;

  }, [tipoVinculo, promotora]);
  
const availableRegionais = useMemo(() => {
    const selectedIds = new Set(selectedRegionais.map(r => String(r.id)));
    
    return regionais 
      .map(r => ({ id: r.id!, nome: r.nome })) 
      .filter(r => !selectedIds.has(String(r.id)))
      .sort((a, b) => a.nome.localeCompare(b.nome));
  }, [regionais, selectedRegionais]);
  
const availableComerciais = useMemo(() => {
    const selectedIds = new Set(selectedComerciais.map(c => String(c.id)));
    
    return comerciais 
      .map(c => ({ id: c.id!, nome: c.nome })) 
      .filter(c => !selectedIds.has(String(c.id)))
      .sort((a, b) => a.nome.localeCompare(b.nome));
  }, [comerciais, selectedComerciais]);

  const handleMoveRegionalToSelected = (items: ListItem[]) => setSelectedRegionais(prev => [...prev, ...items].sort((a, b) => a.nome.localeCompare(b.nome)));
  const handleMoveRegionalToAvailable = (items: ListItem[]) => {
    const idsToMove = new Set(items.map(i => i.id));
    setSelectedRegionais(prev => prev.filter(i => !idsToMove.has(i.id)));
  };
  const handleMoveAllRegionaisToSelected = () => setSelectedRegionais([...regionais.map(r => ({ id: r.id!, nome: r.nome }))].sort((a, b) => a.nome.localeCompare(b.nome)));
  const handleMoveAllRegionaisToAvailable = () => setSelectedRegionais([]);

  const handleMoveComercialToSelected = (items: ListItem[]) => setSelectedComerciais(prev => [...prev, ...items].sort((a, b) => a.nome.localeCompare(b.nome)));
  const handleMoveComercialToAvailable = (items: ListItem[]) => {
    const idsToMove = new Set(items.map(i => i.id));
    setSelectedComerciais(prev => prev.filter(i => !idsToMove.has(i.id)));
  };
  const handleMoveAllComerciaisToSelected = () => setSelectedComerciais([...comerciais.map(c => ({ id: c.id!, nome: c.nome }))].sort((a, b) => a.nome.localeCompare(b.nome)));
  const handleMoveAllComerciaisToAvailable = () => setSelectedComerciais([]);


  return (
    <div className="container">
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={()=> { setAlert(null); if (alert.type === 'success') {window.history.back();} }} />)}
      {loading ? <Spinner loading={loading} /> : (
        <form onSubmit={handleSubmit}>

          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
              {tipo === 'inclusao' ? <h5>Origens &gt; Supervisor &gt; Inclusão</h5> : (
                <h5>Origens &gt; Supervisor &gt; Alteração</h5>
              )}
              <Button id="App-button-cor-principal" onClick={() => window.history.back()}>
                Voltar
              </Button>
            </div>
            <hr className="my-4" />
          </div>
          <h5 className="mb-3">Modo de Vínculo</h5>
          <Form.Group as={Row} className="mb-3">
            <Col sm={10}>
              <Form.Check
                type="radio"
                label="Padrão (Vincular permissões à Promotora)"
                id="vinculo-promotora"
                name="tipoVinculoRadio"
                value="PROMOTORA"
                checked={tipoVinculo === 'PROMOTORA'}
                onChange={(e) => setTipoVinculo(e.target.value)}
              />
              <Form.Check
                type="radio"
                label="Livre (Vincular diretamente à Regional/Comercial)"
                id="vinculo-entidade"
                name="tipoVinculoRadio"
                value="ENTIDADE"
                checked={tipoVinculo === 'ENTIDADE'}
                onChange={(e) => setTipoVinculo(e.target.value)}
              />
            </Col>
          </Form.Group>
          <hr className="my-4" />
          
          <div className="row">
            <div className="col-xl">
              <label>Promotora <span style={{ color: 'red' }}>*</span></label>
              <select className="form-select" 
              value={promotora} 
              onChange={handleChangePromotora} required>
                <option value="" disabled>Selecione...</option>
                {promotoras.map((item) => (
                  <option key={item.id} value={item.id!}>
                    {item.id + ' - ' + item.nome}
                  </option>
                ))}
              </select>
            </div>
          </div>
          
          <div className="row mt-3">
            <div className="col-xl">
              <label>Nome <span style={{ color: 'red' }}>*</span></label>
              <input type="text" required className="form-control" value={nome} onChange={(e) => setNome(e.target.value)} />
            </div>
            <div className="col-xl">
              <label>CPF <span style={{ color: 'red' }}>*</span></label>
              <InputMask required mask="999.999.999-99" type="text" className="form-control" value={cpf} onChange={(e) => setCpf(e.target.value)} />
            </div>
            <div className="col-xl">
              <label>Nº da Certificação</label>
              <input type="number" className="form-control" value={numeroCertificacao} onChange={(e) => setNumeroCertificacao(e.target.value)} />
            </div>
          </div>

          <div className="row">
            <div className="col-xl">
              <label>Lista de E-mails (separados por ';') <span style={{ color: 'red' }}>*</span></label>
              <input type="text" required className="form-control" value={emails} onChange={(e) => setEmails(e.target.value)} />
            </div>
          </div>
          <hr className="my-4" />
          <h5 className="mb-3">Vínculos de Segregação (Opcionais)</h5>

          <Row className="mb-3">
            <Col md={4}>
              <Form.Check
                type="checkbox"
                id="regionalCheckbox"
                label="Vincular à Regional"
                checked={showRegionalBox}
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  setShowRegionalBox(isChecked);
                  if (!isChecked) {
                    setSelectedRegionais([]); 
                  }
                }}
              />
            </Col>
            <Col md={4}> 
              <Form.Check
                type="checkbox"
                id="comercialCheckbox"
                label="Vincular ao Comercial"
                checked={showComercialBox}
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  setShowComercialBox(isChecked);
                  if (!isChecked) {
                    setSelectedComerciais([]); 
                  }
                }}
              />
            </Col>
            
            <Col md={4}> 
              <Form.Check
                type="checkbox"
                id="pdvCheckbox"
                label="Vincular ao Ponto de Venda"
                checked={showPdvBox}
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  setShowPdvBox(isChecked);
                  if (!isChecked) {
                    setSelectedPontoDeVenda([]); 
                  }
                }}
              />
            </Col>
          </Row>

          {loadingHierarquia && <Spinner loading={loadingHierarquia} />}
          {!loadingHierarquia && showRegionalBox && (
            <Row className="mb-3">
               <label>Regionais (Disponíveis da Promotora selecionada)</label>
               <Col md={12}>
                  <DualListBox
                      availableItems={availableRegionais}
                      selectedItems={selectedRegionais}
                      onMoveToSelected={handleMoveRegionalToSelected}
                      onMoveAllToSelected={handleMoveAllRegionaisToSelected}
                      onMoveToAvailable={handleMoveRegionalToAvailable}
                      onMoveAllToAvailable={handleMoveAllRegionaisToAvailable}
                      availableLabel="Regionais Disponíveis"
                      selectedLabel="Regionais Vinculadas"
                  />
               </Col>
            </Row>
          )}

          {!loadingHierarquia && showComercialBox && (
            <Row className="mb-4">
               <label>Comerciais (Disponíveis da Promotora selecionada)</label>
               <Col md={12}>
                  <DualListBox
                      availableItems={availableComerciais}
                      selectedItems={selectedComerciais}
                      onMoveToSelected={handleMoveComercialToSelected}
                      onMoveAllToSelected={handleMoveAllComerciaisToSelected}
                      onMoveToAvailable={handleMoveComercialToAvailable}
                      onMoveAllToAvailable={handleMoveAllComerciaisToAvailable}
                      availableLabel="Comerciais Disponíveis"
                      selectedLabel="Comerciais Vinculados"
                  />
               </Col>
            </Row>
          )}
         {!loadingHierarquia && showPdvBox && (
            <Row className="mb-4">
               <label>
                {tipoVinculo === 'PROMOTORA' 
                  ? 'Pontos de Venda (Disponíveis da Promotora selecionada)' 
                  : 'Pontos de Venda (Todos disponíveis no sistema)'}
               </label>
               <Col md={12}>
                  <DualListBox
                      availableItems={availablePontosDeVenda}
                      selectedItems={selectedPontoDeVenda}
                      onMoveToSelected={handleMovePdvToSelected}
                      onMoveAllToSelected={handleMoveAllPdvsToSelected}
                      onMoveToAvailable={handleMovePdvToAvailable}
                      onMoveAllToAvailable={handleMoveAllPdvsToAvailable}
                      availableLabel="PDVs Disponíveis"
                      selectedLabel="PDVs Vinculados"
                  />
               </Col>
            </Row>
          )}

          <hr className="my-4" />
          <div className="row">
            {loading ? <Spinner loading={loading} /> : false}
            <div className="col-md-2">
              <label>CEP <span style={{ color: 'red' }}>*</span></label>
              <InputMask mask="99.999-999" type="text" className="form-control" required
                value={cep}
                onChange={(e) => setCep(e.target.value)}
                onBlur={(e) => viaCep(e.target.value)}
              />
            </div>
            <div className="col-md">
              <label>Endereço <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" required value={logradouro} onChange={(e) => setLogradouro(e.target.value)} />
            </div>
            <div className="col-md-3">
              <label>Número <span style={{ color: 'red' }}>*</span></label>
              <input type="number" className="form-control" required value={numero} onChange={(e) => setNumero(e.target.value)} />
            </div>
          </div>

          <div className="row">
            <div className="col-md">
              <label>Bairro <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" required value={bairro} onChange={(e) => setBairro(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Complemento</label>
              <input type="text" className="form-control" value={complemento} onChange={(e) => setComplemento(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Cidade <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" required value={localidade} onChange={(e) => setLocalidade(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Estado <span style={{ color: 'red' }}>*</span></label>
              <InputMask mask="aa" type="text" required className="form-control" value={uf} onChange={(e) => setUf(e.target.value.toUpperCase())} />
            </div>
          </div>

          <hr className="my-4" />

          <div className="row">
            <div className="col-md">
              <label className="form-label">Telefone Comercial <span style={{ color: 'red' }}>*</span></label>
              <div className="row">
                <div className="col-md">
                  <InputMask required mask="(99)9999-9999" type="text" className="form-control" value={telefoneComercial} onChange={(e) => setTelefoneComercial(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="col-md">
              <label className="form-label">Telefone Celular <span style={{ color: 'red' }}>*</span></label>
              <div className="row">
                <div className="col-md">
                  <InputMask required mask="(99)99999-9999" type="text" className="form-control" value={telefoneCelular} onChange={(e) => setTelefoneCelular(e.target.value)} />
                </div>
              </div>
            </div>
          </div>

          <hr className="my-4" />
          <div className="row">
            <div className="col-md">              
              <div className="row">
                <div className="col-md">
                  <label>Código Externo</label>
                  <input type="text" className="form-control" value={codigoExterno} onChange={(e) => setCodigoExterno(e.target.value)} />
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <hr className="my-4" />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <button type="button" onClick={limparCampos} className="w-40 btn btn-lg" id="App-button-cor-principal">Limpar Campos</button>
              <button className="w-40 btn btn-primary btn-lg btn-success" type="submit">{tipo !== 'inclusao' ? 'Alterar Supervisor' : 'Salvar Supervisor'}</button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
}

export default SupervisorInclusaoAlteracao;